import React from 'react';
import { Header, Footer } from '../Common';
import MenuItemShop from '../../Common/MenuItemShop/MenuItemShop';
import vogntrojerDesktop from '../../../../assets/cls-dk/school-shop/Vogntrojer-Desktop.jpg';
import vogntrojerMobile from '../../../../assets/cls-dk/school-shop/Vogntrojer-Mobile.jpg';

// Static banner photos per menu item — used until the brand uploads its own
// (Brands → menu item header images); same fallback as the school shop page.
const BANNER_FALLBACK = {
  menu_2: { backgroundImage: vogntrojerDesktop, backgroundImageMobile: vogntrojerMobile },
};

/**
 * CLS-DK page for a header menu item (/clothing/cls-dk/shop/:menuSlug): the OPEN SHOP
 * page when the open shop is configured for the item, else the fallback listing.
 */
const CLSDKMenuItemShop = () => (
  <MenuItemShop
    brandSlug="clsdk"
    feSlug="cls-dk"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Pakkeløsning"
    schoolAware
    packagesCaption="Spar op til 20%"
    packagesTitle="Pakker"
    moreLabel="flere"
    bannerFallback={BANNER_FALLBACK}
    oddCard="first"
    loadingText="Indlæser produkter…"
    emptyTitle="Ingen produkter lige nu"
    emptyText="Kollektionen er muligvis ved at blive opdateret. Har du spørgsmål, er vi klar til at hjælpe."
    contactLabel="Kontakt os"
    faqLabel="Se FAQ"
  />
);

export default CLSDKMenuItemShop;
